import React from 'react'

import PageContent from './PageContent'
import ProcessesViewModeWrapper from '../shared/ProcessesViewModeWrapper'

const ProcessesListPage = ({ id }) => {
  return (
    <ProcessesViewModeWrapper id={id}>
      <PageContent id={id} />
    </ProcessesViewModeWrapper>
  )
}

export default ProcessesListPage
